import moment from 'moment'
import { v4 as uuid } from 'uuid'
import {
  fetchWithToken,
} from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const PlateauProductService = {
  getPlateauProducts(idPlateau) {
    const filter = JSON.stringify([{ 'field': 'idPlateau', 'operator': '=', 'value': idPlateau }])
    return fetchWithToken(`${config().syncService}/plateauxProduct?filters=${filter}`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  save(customProduct) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const customProductUUid = uuid()

    if (!customProduct._id) {
      const finalCustomProduct = {
        ...customProduct,
        _id: customProductUUid,
        lastUpdate,
        deleted: false,
      }
      return fetchWithToken(`${config().syncService}/plateauxProduct`, {
        method: 'PUT',
        body: JSON.stringify([finalCustomProduct]),
      }).then((body) => body.json())
        .then(() => ({
          ...finalCustomProduct,
          idPlateau: finalCustomProduct.idPlateau,
          lastUpdate,
        }))
    }
    return fetchWithToken(`${config().syncService}/plateauxProduct`, {
      method: 'PUT',
      body: JSON.stringify([{ ...customProduct, lastUpdate }]),
    }).then((body) => body.json())
      .then(() => ({
        ...customProduct,
        idPlateau: customProduct.idPlateau,
        lastUpdate,
      }))
  },
}
